var map = {
	"./Home copy.vue": [
		"d7c2",
		"chunk-2d21f0b8"
	],
	"./Home.vue": [
		"bb51"
	],
	"./Notification.vue": [
		"109a",
		"chunk-49f22c18"
	],
	"./Notifications.vue": [
		"fda7"
	],
	"./Pos.vue": [
		"9a5f"
	],
	"./PosPrescription.vue": [
		"dd4c",
		"chunk-6c9aaa55",
		"chunk-054ddbeb"
	],
	"./account_settings/AccountDefaultSettings.vue": [
		"5181",
		"chunk-98383fd6"
	],
	"./account_settings/AccountDefaultSettings_backup20250209.vue": [
		"2fe8",
		"chunk-337e4ce6"
	],
	"./account_settings/BankAccount.vue": [
		"004b"
	],
	"./account_settings/CostCenter.vue": [
		"dc7b",
		"chunk-7612288b"
	],
	"./account_settings/FiscalYear.vue": [
		"988d",
		"chunk-eb8646c6"
	],
	"./account_settings/LedgerCreateDefaultSettings.vue": [
		"61a2",
		"chunk-3f3f9e28"
	],
	"./account_settings/ProfitCenter.vue": [
		"ee36",
		"chunk-3f1c8515"
	],
	"./account_settings/TransactionDefaultSettings.vue": [
		"3539",
		"chunk-57691a45"
	],
	"./account_settings/TransactionEntryTypes.vue": [
		"9f8f",
		"chunk-06ea7ad6"
	],
	"./accounts/CustomerCollection.vue": [
		"81e4",
		"chunk-64288a1e"
	],
	"./accounts/FiscalYearClosing.vue": [
		"c7f8",
		"chunk-c0118c62"
	],
	"./accounts/FiscalYearClosingList.vue": [
		"2823",
		"chunk-36c49ef2"
	],
	"./accounts/OpeningBalanceEntry.vue": [
		"59f0",
		"chunk-f129f4a2"
	],
	"./accounts/PayBills.vue": [
		"9ca6",
		"chunk-12719ede",
		"chunk-0b7e0650"
	],
	"./accounts/ReceivePayment.vue": [
		"c524",
		"chunk-12719ede",
		"chunk-9da8f59a"
	],
	"./accounts/ReceivePaymentList.vue": [
		"01c3",
		"chunk-72ca2505"
	],
	"./accounts/SupplierLedger.vue": [
		"9539"
	],
	"./accounts/VoucherEntry.vue": [
		"7983",
		"chunk-7f5df270"
	],
	"./accounts/VoucherEntryEdit.vue": [
		"ab92"
	],
	"./accounts/VoucherEntryList.vue": [
		"b5198",
		"chunk-8723fd04"
	],
	"./coa/AccountClass.vue": [
		"6358",
		"chunk-5d15d798"
	],
	"./coa/AccountLedger.vue": [
		"2d72",
		"chunk-624222fe"
	],
	"./coa/AccountLedgerOld.vue": [
		"3955",
		"chunk-13849858"
	],
	"./coa/AccountType.vue": [
		"a9e0",
		"chunk-1d65b406"
	],
	"./coa/AccountTypeOld.vue": [
		"9082",
		"chunk-085b9469"
	],
	"./coa/ChartOfAccount.vue": [
		"f63d",
		"chunk-f4c50cba"
	],
	"./coa/ChartOfAccountList.vue": [
		"0d12",
		"chunk-2d0af04b"
	],
	"./cogs_account_posting/COGSAccountPosting.vue": [
		"c87e",
		"chunk-3d51cf77"
	],
	"./dental/billings/DentalBilling.vue": [
		"a4a2",
		"chunk-4ad6fe6e"
	],
	"./dental/billings/DentalBillingList.vue": [
		"f195",
		"chunk-5ff46578"
	],
	"./dental/patient/ContractPatient.vue": [
		"9d16",
		"chunk-10159e59"
	],
	"./dental/product/ServiceStockDetails.vue": [
		"8370",
		"chunk-170e080c"
	],
	"./dental/product/ServiceStockTransfer.vue": [
		"bc1e",
		"chunk-0d243f06"
	],
	"./dental/reports/ServiceReport.vue": [
		"0abd",
		"chunk-75448737"
	],
	"./dental/services/index.vue": [
		"7aab",
		"chunk-245b3474"
	],
	"./dental/services/service_configuration.vue": [
		"0a62",
		"chunk-2d0ae5a3"
	],
	"./drawer/Category.vue": [
		"a1b3"
	],
	"./expire_product/ExpiryBoard.vue": [
		"5e98"
	],
	"./helper/Modal.vue": [
		"8bd8"
	],
	"./hospital_management/appointments/Appointments.vue": [
		"ee0e"
	],
	"./hospital_management/appointments/CreateAppointments.vue": [
		"3443",
		"chunk-b27ceb04"
	],
	"./hospital_management/appointments/CreateAppointmentsBackup.vue": [
		"6066",
		"chunk-7f487225"
	],
	"./hospital_management/appointments/DoctorSchedule.vue": [
		"d0eb",
		"chunk-7700738e"
	],
	"./hospital_management/appointments/DoctorScheduleV1.vue": [
		"95e9",
		"chunk-d637b950"
	],
	"./hospital_management/appointments/DoctorScheduleV2.vue": [
		"54c6",
		"chunk-2d0c8808"
	],
	"./hospital_management/appointments/TodayAppointments.vue": [
		"cb85",
		"chunk-6df29d8a"
	],
	"./hospital_management/billing/CompleteDiagnosisBilling.vue": [
		"3c5f",
		"chunk-5c48e554"
	],
	"./hospital_management/billing/DiagnosisBilling.vue": [
		"418e",
		"chunk-0c8ca64e"
	],
	"./hospital_management/billing/DiagnosisBillingList.vue": [
		"619e",
		"chunk-577d3d52"
	],
	"./hospital_management/billing/DueBillingList.vue": [
		"b7b5",
		"chunk-18d6dd00"
	],
	"./hospital_management/billing/EditDiagnosisBilling.vue": [
		"c137",
		"chunk-0e23b010"
	],
	"./hospital_management/billing/TodayDiagnosisBilling.vue": [
		"c038",
		"chunk-52420bda"
	],
	"./hospital_management/diagnosis/Categories.vue": [
		"5ade",
		"chunk-082b1d1e"
	],
	"./hospital_management/diagnosis/ReportGenerateProcess.vue": [
		"1da0",
		"chunk-49fbbb48"
	],
	"./hospital_management/diagnosis/ReportReceiveProcess.vue": [
		"ff19",
		"chunk-2c866899"
	],
	"./hospital_management/diagnosis/SampleCollectionProcess.vue": [
		"467e",
		"chunk-4371dbd6"
	],
	"./hospital_management/diagnosis/TestCompleteProcess.vue": [
		"5ced",
		"chunk-2cc045dc"
	],
	"./hospital_management/diagnosis/TestExpenseHead.vue": [
		"faf5",
		"chunk-5f44a080"
	],
	"./hospital_management/diagnosis/TestUnits.vue": [
		"a02e",
		"chunk-7a9e228e"
	],
	"./hospital_management/diagnosis/Tests.vue": [
		"474a",
		"chunk-33fb4db0"
	],
	"./hospital_management/doctors/Doctor.vue": [
		"f948",
		"chunk-41a9c6a8"
	],
	"./hospital_management/patients/AllPatients.vue": [
		"037b",
		"chunk-18a6afba"
	],
	"./hospital_management/patients/PatientDetails.vue": [
		"46787",
		"chunk-75993a9e"
	],
	"./hospital_management/patients/PatientDetailsDynamicTab.vue": [
		"dd0d",
		"chunk-51e96c6c"
	],
	"./hospital_management/patients/TodayPatients.vue": [
		"f7f2",
		"chunk-5cb15306"
	],
	"./hospital_management/patients/TodayPatientsV1.vue": [
		"bd0b",
		"chunk-40de37c2"
	],
	"./hospital_management/reports/DoctorServiceReport.vue": [
		"2fba",
		"chunk-83f609f4"
	],
	"./hospital_management/reports/DoctorServiceReportOld.vue": [
		"c32a",
		"chunk-8545e2a4"
	],
	"./hospital_management/reports/TestServiceReport.vue": [
		"0885",
		"chunk-675b50d8"
	],
	"./hospital_management/settings/DiscountSetup.vue": [
		"a61b",
		"chunk-a602f3ca"
	],
	"./hospital_management/settings/TestConfigurationSetup.vue": [
		"67ba",
		"chunk-64a04cf8"
	],
	"./inventory/InventoryBoard.vue": [
		"a9bf"
	],
	"./menu_and_permissions/ModuleOrMenu.vue": [
		"59bf"
	],
	"./menu_and_permissions/PermissionAction.vue": [
		"5d1c"
	],
	"./pad_prescription/PrescriptionGenerate.vue": [
		"64a8",
		"chunk-0b77686c"
	],
	"./page/About.vue": [
		"e3eb",
		"chunk-48c7d09a"
	],
	"./page/Area.vue": [
		"ecc9",
		"chunk-742d1c92"
	],
	"./page/AttributeValue.vue": [
		"c5d8"
	],
	"./page/Attributes.vue": [
		"1ca4"
	],
	"./page/Brand.vue": [
		"92fc"
	],
	"./page/Colors.vue": [
		"7f91"
	],
	"./page/Company.vue": [
		"2299"
	],
	"./page/CompanyAdd.vue": [
		"1940",
		"chunk-2d0ac39a"
	],
	"./page/Conpons.vue": [
		"db46"
	],
	"./page/Customer.vue": [
		"3fb6"
	],
	"./page/CustomerGroup.vue": [
		"5fba"
	],
	"./page/CustomerLedger.vue": [
		"f70e"
	],
	"./page/Department.vue": [
		"f10f"
	],
	"./page/Districts.vue": [
		"8836"
	],
	"./page/Inventory.vue": [
		"8ba1",
		"chunk-6ce344c6"
	],
	"./page/Login.vue": [
		"c36b"
	],
	"./page/MobileWallet.vue": [
		"6942"
	],
	"./page/NumberToWord.vue": [
		"e799"
	],
	"./page/Outlet.vue": [
		"0689"
	],
	"./page/ProductCategory.vue": [
		"f938"
	],
	"./page/Product_List_Item.vue": [
		"7a0f",
		"chunk-2d0e13b6"
	],
	"./page/Role.vue": [
		"d514"
	],
	"./page/RolePermission.vue": [
		"9dba"
	],
	"./page/RolePermissionWithComponent.vue": [
		"d194",
		"chunk-aa8ca41a"
	],
	"./page/Sizes.vue": [
		"d44b"
	],
	"./page/Supplier.vue": [
		"a4e2"
	],
	"./page/SupplierType.vue": [
		"e0c6"
	],
	"./page/Taxes.vue": [
		"54ab"
	],
	"./page/Unit.vue": [
		"2fc0"
	],
	"./page/UnitConversion.vue": [
		"065a",
		"chunk-0824144c"
	],
	"./page/User.vue": [
		"4d7e"
	],
	"./page/Warehouse.vue": [
		"23d6"
	],
	"./pos/Autocomplete.vue": [
		"e96e",
		"chunk-188fe40b"
	],
	"./pos/BackPosLeftbar.vue": [
		"4a9c",
		"chunk-367433f3"
	],
	"./pos/PosLeftbar-V1.vue": [
		"4b17",
		"chunk-5b7b554e"
	],
	"./pos/PosLeftbar.vue": [
		"caca"
	],
	"./pos/PosLeftbarBack.vue": [
		"085f",
		"chunk-26989d9d"
	],
	"./pos/PosLeftbarOld.vue": [
		"0446",
		"chunk-91ac8458"
	],
	"./pos/PosLeftbarPrescription copy.vue": [
		"d6ea",
		"chunk-130d1a46"
	],
	"./pos/PosLeftbarPrescription.vue": [
		"f0d8",
		"chunk-6c9aaa55"
	],
	"./pos/PosLeftbarTestOld.vue": [
		"466c"
	],
	"./pos/PosRightbar.vue": [
		"b634"
	],
	"./pos/Product_List_Item.vue": [
		"65be"
	],
	"./pos_report/CollectionReport.vue": [
		"9790",
		"chunk-3b9074ec"
	],
	"./pos_report/DailySalesReport.vue": [
		"aa25",
		"chunk-74b53556"
	],
	"./pos_report/DailySummaryReport.vue": [
		"5c5a",
		"chunk-fdbcfffc"
	],
	"./pos_report/DetailsStockReport.vue": [
		"9bb6",
		"chunk-26ab2d72"
	],
	"./pos_report/InventoryDetailsReport.vue": [
		"5cef",
		"chunk-7143162a"
	],
	"./pos_report/InventorySummary.vue": [
		"05a6",
		"chunk-79603b2a"
	],
	"./pos_report/LowStockReport.vue": [
		"8e89",
		"chunk-2beec29d"
	],
	"./pos_report/ProductPurchaseReport.vue": [
		"51fe",
		"chunk-b1d6646e"
	],
	"./pos_report/ProductSalesReport.vue": [
		"b6a3",
		"chunk-5f9b42c6"
	],
	"./pos_report/PurchaseReport.vue": [
		"8d7e",
		"chunk-11a2e2b0"
	],
	"./pos_report/SaleReport.vue": [
		"17a0",
		"chunk-7fd60f24"
	],
	"./pos_report/StockReport.vue": [
		"bba0",
		"chunk-3b36ea03"
	],
	"./pos_report/SupplierStockReport.vue": [
		"4bdf",
		"chunk-c3fa6592"
	],
	"./product/BarcodeDemo.vue": [
		"2e17"
	],
	"./product/Bulkupload.vue": [
		"25fd"
	],
	"./product/Product.vue": [
		"4ba7"
	],
	"./product/ProductBackup.vue": [
		"2972",
		"chunk-53894b2e"
	],
	"./product/Product_List_Item.vue": [
		"28f6",
		"chunk-2d0b3a4c"
	],
	"./purchase/PurchaseOrder.vue": [
		"d66d"
	],
	"./purchase/PurchaseOrderApprovalList.vue": [
		"aedb"
	],
	"./purchase/PurchaseOrderEdit.vue": [
		"43d2"
	],
	"./purchase/PurchaseOrderList copy.vue": [
		"e2a1",
		"chunk-7f457795"
	],
	"./purchase/PurchaseOrderList.vue": [
		"09ae"
	],
	"./purchase/PurchaseReceive.vue": [
		"6e8e"
	],
	"./purchase/PurchaseReceiveBoard.vue": [
		"3077"
	],
	"./purchase/PurchaseReceiveList.vue": [
		"91fa"
	],
	"./purchase/WarehousePurchaseReceive.vue": [
		"d427"
	],
	"./purchase/WarehousePurchaseReceiveOld.vue": [
		"d4c5",
		"chunk-1fd0d3ee"
	],
	"./purchase_requisition/StorePurchaseRequisition.vue": [
		"d9ad"
	],
	"./purchase_requisition/StorePurchaseRequisitionEdit.vue": [
		"2e47"
	],
	"./purchase_requisition/StoreRequisitionApprovalList.vue": [
		"2ad8"
	],
	"./purchase_requisition/StoreRequisitionList.vue": [
		"bb23"
	],
	"./purchase_requisition/StoreRequisitionPurchaseOrder.vue": [
		"c933"
	],
	"./purchase_requisition/StoreRequisitionPurchaseOrderEdit.vue": [
		"4460"
	],
	"./purchase_return/PurchaseReturn.vue": [
		"f3e3",
		"chunk-fe2351de"
	],
	"./purchase_return/PurchaseReturnList.vue": [
		"c479",
		"chunk-aee227dc"
	],
	"./reports/BalanceSheet.vue": [
		"300f",
		"chunk-f285d09e"
	],
	"./reports/BankBook.vue": [
		"7250",
		"chunk-744791fd"
	],
	"./reports/CashAndBankBook.vue": [
		"ad70",
		"chunk-29438dda"
	],
	"./reports/CashBook.vue": [
		"32d9",
		"chunk-5cd64804"
	],
	"./reports/DailyTransaction.vue": [
		"d8a5",
		"chunk-2b972bdc"
	],
	"./reports/LedgerReport.vue": [
		"50bd",
		"chunk-8efb6ae8"
	],
	"./reports/ProfitLoss copy.vue": [
		"98ed",
		"chunk-5f4fd163"
	],
	"./reports/ProfitLoss.vue": [
		"47ec",
		"chunk-58519ef3"
	],
	"./reports/TrialBalance.vue": [
		"02ba",
		"chunk-a9e2d682"
	],
	"./rewards-points/OrderTatalPoints.vue": [
		"0b0c"
	],
	"./rewards-points/OrderTotalPoints.vue": [
		"7471",
		"chunk-0ea0d0dd"
	],
	"./rewards-points/PointsSettings.vue": [
		"2b57"
	],
	"./rewards-points/RewardsPoints.vue": [
		"1b45a"
	],
	"./sales/DiscountSettings.vue": [
		"9909"
	],
	"./sales/DueSales.vue": [
		"2985",
		"chunk-3f499fe4"
	],
	"./sales/HoldSales.vue": [
		"164c",
		"chunk-9dc8d3aa",
		"chunk-edf664c8"
	],
	"./sales/LoyaltySettings.vue": [
		"f84e",
		"chunk-41e8cc4c"
	],
	"./sales/PosSales.vue": [
		"17cf"
	],
	"./sales/PosSalesOld.vue": [
		"61a9",
		"chunk-50864234"
	],
	"./sales/PosSalesOld2-22.vue": [
		"b189",
		"chunk-345afced"
	],
	"./sales/SalesReturn.vue": [
		"0beb",
		"chunk-9dc8d3aa",
		"chunk-91c38fb6"
	],
	"./sales_account_posting/SalesAccountPosting.vue": [
		"f440",
		"chunk-8631ac04"
	],
	"./settings/GeneralSettings.vue": [
		"1beb",
		"chunk-336b98a6"
	],
	"./stock/DamageProductManagement.vue": [
		"7103",
		"chunk-4d0485d4"
	],
	"./stock/StockInOut.vue": [
		"70ea"
	],
	"./stock/StockManagement.vue": [
		"bae8"
	],
	"./stock/WarehouseStockManagement.vue": [
		"89b0",
		"chunk-4ca68f95"
	],
	"./stock_transfer/StockTransfer.vue": [
		"c895"
	],
	"./stock_transfer/StockTransferList.vue": [
		"4642"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;